<div class="container-fluid mt-3">
  <p-toast></p-toast>

  <div class="d-flex justify-content-between align-items-center mb-3">
    <h4 class="mb-0">{{templateId ? 'Edit' : 'New'}} Drip Campaign Template</h4>
    <div>
      <button pButton type="button" label="Cancel" icon="pi pi-times"
              class="p-button-secondary mr-2" (click)="onCancel()"></button>
      <button pButton type="button" label="Save" icon="pi pi-check"
              class="p-button-success" [disabled]="saving" (click)="onSave()">
        <span *ngIf="saving"><i class="pi pi-spin pi-spinner mr-1"></i></span>
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="text-center p-4">
    <i class="pi pi-spin pi-spinner" style="font-size:2rem"></i>
  </div>

  <div *ngIf="!loading">
    <!-- Template header form -->
    <div class="card mb-3">
      <div class="card-body">
        <form [formGroup]="form">
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label>Name <span class="text-danger">*</span></label>
                <input pInputText formControlName="name" class="form-control"
                       placeholder="e.g. Quote 6-24-72 Follow-up" />
                <small class="text-danger"
                       *ngIf="form.get('name').invalid && form.get('name').touched">Required</small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Applicable Task Source</label>
                <p-dropdown [options]="taskSourceOptions" formControlName="applicableTaskSource"
                            optionLabel="label" optionValue="value"
                            [style]="{'width':'100%'}" placeholder="Any"></p-dropdown>
              </div>
            </div>
            <div class="col-md-2 d-flex align-items-center pt-3">
              <p-inputSwitch formControlName="active"></p-inputSwitch>
              <span class="ml-2">Active</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-10">
              <div class="form-group">
                <label>Description</label>
                <textarea pInputTextarea formControlName="description" class="form-control" rows="2"
                          placeholder="Optional description"></textarea>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Step editor -->
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <strong>Steps ({{steps.length}})</strong>
        <button pButton type="button" label="Add Step" icon="pi pi-plus"
                class="p-button-sm p-button-outlined" (click)="addStep()"></button>
      </div>
      <div class="card-body p-0">
        <table class="table table-sm table-bordered mb-0">
          <thead class="thead-light">
            <tr>
              <th style="width:40px">#</th>
              <th style="width:90px">Delay (hrs)</th>
              <th style="width:130px">Channel</th>
              <th>Message / Payload</th>
              <th style="width:70px">Stop?</th>
              <th style="width:80px">Order</th>
              <th style="width:40px"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let step of steps; let i = index">
              <td class="text-center align-middle">{{step.stepOrder}}</td>
              <td>
                <input pInputText type="number" [(ngModel)]="step.delayHours" class="form-control form-control-sm"
                       min="0" style="width:70px" />
              </td>
              <td>
                <p-dropdown [options]="channelOptions" [(ngModel)]="step.channel"
                            optionLabel="label" optionValue="value"
                            [style]="{'width':'100%'}"
                            (onChange)="onChannelChange(step)"></p-dropdown>
              </td>
              <td>
                <!-- email / sms / vrbo: msg template autocomplete -->
                <ng-container *ngIf="isMsgChannel(step.channel)">
                  <p-autoComplete
                    [(ngModel)]="step.msgTemplateId"
                    [suggestions]="step.msgTemplateOptions"
                    (completeMethod)="searchMsgTemplates($event, step)"
                    (onSelect)="onMsgTemplateSelect($event, step)"
                    field="name"
                    [forceSelection]="false"
                    placeholder="Search msg template..."
                    [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}"
                    [minLength]="1">
                    <ng-template let-t pTemplate="item">
                      <span>{{t.name}}</span>
                      <small class="text-muted ml-2">#{{t.msgTemplateId}}</small>
                    </ng-template>
                  </p-autoComplete>
                </ng-container>

                <!-- phoneTask -->
                <ng-container *ngIf="step.channel === 'phoneTask'">
                  <div class="d-flex gap-2">
                    <input pInputText [(ngModel)]="step.taskName" placeholder="Task name"
                           class="form-control form-control-sm mr-1" />
                    <input pInputText type="number" [(ngModel)]="step.dueHoursOffset"
                           placeholder="Due hrs" class="form-control form-control-sm"
                           style="width:90px" />
                  </div>
                </ng-container>

                <!-- note -->
                <ng-container *ngIf="step.channel === 'note'">
                  <input pInputText [(ngModel)]="step.noteText" placeholder="Note text"
                         class="form-control form-control-sm" />
                </ng-container>

                <!-- markStatus -->
                <ng-container *ngIf="step.channel === 'markStatus'">
                  <p-dropdown [options]="finalStatusOptions" [(ngModel)]="step.finalStatus"
                              optionLabel="label" optionValue="value"
                              [style]="{'width':'100%'}" placeholder="Select status"></p-dropdown>
                </ng-container>
              </td>
              <td class="text-center align-middle">
                <p-checkbox [(ngModel)]="step.stopOnExecute" [binary]="true"></p-checkbox>
              </td>
              <td class="text-center align-middle">
                <button pButton type="button" icon="pi pi-arrow-up"
                        class="p-button-sm p-button-text" title="Move up"
                        [disabled]="i === 0" (click)="moveUp(i)"></button>
                <button pButton type="button" icon="pi pi-arrow-down"
                        class="p-button-sm p-button-text" title="Move down"
                        [disabled]="i === steps.length - 1" (click)="moveDown(i)"></button>
              </td>
              <td class="text-center align-middle">
                <button pButton type="button" icon="pi pi-times"
                        class="p-button-sm p-button-text p-button-danger"
                        title="Remove" (click)="removeStep(i)"></button>
              </td>
            </tr>
            <tr *ngIf="steps.length === 0">
              <td colspan="7" class="text-center text-muted p-3">
                No steps yet. Click "Add Step" to begin.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
